import React from "react";
import styles from "./AdvancedSearch.module.scss";
import AutocompleteInput from "../forms/AutocompleteInput";
import TagBubble from "../forms/TagBubble";

type Props = {
  handleChange: (field: string, value: string) => void;
  handleRemove: (field: string, index: number) => void;
  options: Array<string>;
  selectedTerms: Array<string>;
  id: string;
  field: string;
  label: string;
  placeholder: string;
  helper?: React.ReactNode;
};
const AdvancedSearchTermInput: React.FC<Props> = ({
  handleChange,
  handleRemove,
  options,
  selectedTerms,
  id,
  field,
  label,
  placeholder,
  helper,
}) => {
  return (
    <>
      <AutocompleteInput
        handler={(val) => {
          if (options.includes(val)) {
            handleChange(field, val);
            return true;
          } else {
            return false;
          }
        }}
        id={id}
        name={field}
        options={options}
        label={label}
        labelClass={styles["c-advanced-search__input-label"]}
        inputClass={styles["c-advanced-search__input"]}
        placeholder={placeholder}
      />
      {selectedTerms.map((el, i) => {
        return (
          <TagBubble
            key={i}
            index={i}
            name={el}
            removeHandler={(i) => handleRemove(field, i)}
          />
        );
      })}
      {helper ? helper : null}
    </>
  );
};

export default AdvancedSearchTermInput;
